import PopAnimationModule from './PopAnimationModule';

export default PopAnimationModule;
